import { render, staticRenderFns } from "./SubGovernanceCreate.vue?vue&type=template&id=4b12fad4&scoped=true&"
import script from "./SubGovernanceCreate.vue?vue&type=script&lang=js&"
export * from "./SubGovernanceCreate.vue?vue&type=script&lang=js&"
import style0 from "./SubGovernanceCreate.vue?vue&type=style&index=0&id=4b12fad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b12fad4",
  null
  
)

export default component.exports